module.exports = __webpack_public_path__ + "images/icon-tower-1f096fa2167a0091a2df7b9537166bf7.png";